// Enables active states on mobile browsers
// ------------------------------------------------------
document.body.addEventListener('touchstart', function () {}, false);